<template>
    <!-- <div v-if="uploadFilePage">
        <router-view/>
    </div>
    <div v-else-if="uploadImgPage">
        <router-view/>
    </div> -->
    <div id="app">
        <!-- <div class="header"> -->
            <!-- <main-header></main-header> -->
        <!-- </div> -->
        <div class="body">
            <router-view/>
        </div>
    </div>
</template>

<script>
    // import mainHeader from './components/common/mainHeader'
    export default {
        name: 'App',
        // components:{
        //     mainHeader,
        // },
        watch: {
          $route: {
            handler: function(val, oldVal){
              console.log(val,'vall11111');
            },
            // 深度观察监听
            deep: true
          }
        },
        computed:{
            uploadFilePage(){
                return this.$route.name == "uploadFile";
            },
            uploadImgPage(){
                return this.$route.name == "uploadImg";
            },
        },
    }
</script>

<style lang="scss" scoped>
// 滚动条
/deep/ .el-table__body-wrapper::-webkit-scrollbar {
    width: 10px; // 横向滚动条
    height: 10px; // 纵向滚动条 必写
  }
    #app {
        height: 100%;
        overflow: hidden;
        background: #fff;
        .header {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 56px;
            overflow: hidden;
            border-bottom: 1px solid #d2d2d2;
        }
        .body {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            overflow-x: hidden;
            overflow-y: auto;
        }
        *::-webkit-scrollbar {
            width: 10px;
        }
        *::-webkit-scrollbar-track{
            background-color: rgb(210, 211, 215);
            border-radius: 3px;
        }
        *::-webkit-scrollbar-thumb{
            border-radius: 7px;
            background-color: #bbb;
        }
    }
</style>



// WEBPACK FOOTER //
// src/App.vue